import { Button, Heading, Pane, SelectField, TextInputField } from 'evergreen-ui';
import React from 'react';
import { connect } from 'react-redux';
import Request from '../../../util/Api';
import { getCategories } from '../../categories/actions/CategoryActions';
import MainChart from '../components/MainChart';



class SalesReport extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            timeGroup: 'monthly',
            rangeStart: '2024-01-01',
            rangeEnd: '2025-12-31',
            locationKeys: [],
            aggregateLocation: [],
            categoryKeys: [],
            aggregateCategory: [],
        }

        this.generateReport = this.generateReport.bind(this);
        this.processDataPerMethod = this.processDataPerMethod.bind(this);
    }

    async componentDidMount() {
        await this.props.dispatch(getCategories())
    }


    async generateReport() {
        // Logic to generate the sales report
        console.log('Loading raw report data');

        const data = await Request.get('/reports/v2/sales-report', null, {
            timeGroup: this.state.timeGroup,
            rangeStart: this.state.rangeStart,
            rangeEnd: this.state.rangeEnd
        });

        this.setState({ rawData: data.results });


        console.log('Loaded data');

        const aggregateLocation = await this.processDataPerMethod(data.results);
        const aggregateCategory = await this.processDataPerCategory(data.results);

        this.setState({ aggregateLocation, aggregateCategory });
    }

    updateCategoryFilter(categoryId) {
        this.setState({ category: categoryId });

        const filteredData = this.state.rawData.filter(record => {
            return record.categoryGroup.includes(categoryId);
        }).map(record => (
            {
                ...record,
                categoryGroup: record.categoryGroup.slice(record.categoryGroup.indexOf(categoryId) + 1)
            }
        ));

        console.log('Filtered data', filteredData);

        const aggregateCategory = this.processDataPerCategory(filteredData);
        const aggregateLocation = this.processDataPerMethod(filteredData);

        this.setState({ aggregateCategory, aggregateLocation });
    }

    processDataPerCategory(data) {
        console.log('Processing data');
        const categoryKeys = {};

        const categoryNormalized = data.map(record => {
            let category = record.categoryGroup[0];

            if(!categoryKeys[category]) {
                categoryKeys[category] = this.props.categories.flatData.find(cat => cat.id == category)?.name;
            }

            if(!category) {
                category = 'Uncategorized';
            }

            return {
                ...record,
                categoryGroup: category
            }
        });

        const aggregateData = categoryNormalized.reduce((acc, record) => {
            const key = `${record.timeGroup}`;
            if (!acc[key]) {
                acc[key] = {
                    timeGroup: record.timeGroup,
                };
            }

            const categoryGroup = this.props.categories.flatData.find(cat => cat.id == record.categoryGroup)?.name;

            if(!acc[key][categoryGroup]) {
                acc[key][categoryGroup] = 0;
            }

            acc[key][categoryGroup] += Math.round(parseFloat(record.total));
            return acc;
        }, {});

        console.log('Processed data');


        this.setState({ categoryKeys: Object.values(categoryKeys) });
        console.log('CATKEYS', categoryKeys);



        return aggregateData;
    }

    processDataPerMethod(data) {
        console.log('Processing data');

        const locationKeys = {};

        const aggregateData = data.reduce((acc, record) => {
            const key = `${record.timeGroup}`;
            if (!acc[key]) {
                acc[key] = {
                    timeGroup: record.timeGroup,
                };
            }

            if(!acc[key][record.locationGroup]) {
                acc[key][record.locationGroup] = 0;
            }

            locationKeys[record.locationGroup] = record.locationGroup;

            acc[key][record.locationGroup] += Math.round(parseFloat(record.total));
            return acc;
        }, {});

        console.log('Processed data');


        this.setState({ locationKeys: Object.keys(locationKeys) });

        return aggregateData;
    }

    render() {
         return <>
            <Heading size={600} marginBottom={20}>
                Sales Report
            </Heading>
            <Pane display="flex" flexDirection="row" gap={16}>
                <Button appearance={this.state.timeGroup === 'monthly' ? 'primary' : 'secondary'} onClick={() => { this.setState({ timeGroup: 'monthly'}) }}>
                    Lunar
                </Button>

                <Button appearance={this.state.timeGroup === 'weekly' ? 'primary' : 'secondary'} onClick={() => { this.setState({ timeGroup: 'weekly'}) }}>
                    Saptamanal
                </Button>

                <Button appearance={this.state.timeGroup === 'daily' ? 'primary' : 'secondary'} onClick={() => { this.setState({ timeGroup: 'daily'}) }}>
                    Zilnic
                </Button>

                <Pane display="flex">
                    <TextInputField marginLeft={10} type="date" placeholder="Start" value={this.state.rangeStart} onChange={event => this.setState({ rangeStart: event.target.value })} />
                    <TextInputField marginLeft={10} type="date" placeholder="End" value={this.state.rangeEnd} onChange={event => this.setState({ rangeEnd: event.target.value })} />
                </Pane>

                <Button appearance="primary" onClick={() => { this.generateReport() }}>
                    Generate Report
                </Button>
            </Pane>
            {this.state.aggregateLocation && this.state.aggregateCategory && (
                <Pane>
                    <Pane display="flex">
                        <SelectField
                            name="category"
                            value={this.state.category}
                            onChange={(e) => this.updateCategoryFilter(e.target.value)}
                        >
                            <option value="">Selecteaza o categorie</option>
                            {this.props.categories.flatData.map(category => (
                                <option key={category.id} value={category.id}>{category.label || category.title}</option>
                            ))}
                        </SelectField>
                    </Pane>
                    <MainChart keys={['Livrare', 'Easybox', 'Ploiesti', 'Brasov']} data={this.state.aggregateLocation} />
                    <MainChart keys={this.state.categoryKeys} data={this.state.aggregateCategory} />
                </Pane>
            )}
         </>
    }

}

function mapStateToProps(state) {
    return state
}

export default connect(mapStateToProps)(SalesReport);
